import type { CargoPlanningStatusDto } from "../../dto/Applications/CargoPlanningDto";

export type CargoPlanningState = CargoPlanningStatusDto & {
  applicationId?: number;
  savedDocumentIds: number[];
  applicationMetadataKey: string;
  applicationUpdatedAt: number;
  refreshVersion: number;
  checking: boolean;
  confirmed: boolean;
  statusError: boolean;
  saving: boolean;
  saveError: boolean;
  uploadingFiles: number;
  modalOpen: boolean;
  modalSession: number;
  loadingUrl: boolean;
  urlError: boolean;
  url?: string;
};

export const initialCargoPlanningState: CargoPlanningState = {
  dealId: null,
  syncState: "NOT_STARTED",
  documents: [],
  savedDocumentIds: [],
  applicationMetadataKey: "",
  applicationUpdatedAt: 0,
  refreshVersion: 0,
  checking: false,
  confirmed: false,
  statusError: false,
  saving: false,
  saveError: false,
  uploadingFiles: 0,
  modalOpen: false,
  modalSession: 0,
  loadingUrl: false,
  urlError: false,
};
